export function SkeletonLoadingText() {
  return (
    <div className="flex h-4 animate-pulse flex-row items-center md:mb-1">
      <div className="h-4 w-32 rounded-md bg-gray-100 md:mt-2 md:h-4"></div>
    </div>
  );
}
